import theme from './__ACTIVE_THEME__/params'

export const themes = {
    [theme.name]: theme
}
